import { Controller } from "@hotwired/stimulus";
import Pickr from "@simonwep/pickr";
import CustomizationRequest from "./customization/request";
import Customization from "./customization";
import { onCustomizationRendered } from "./customization/event";
import { swatches } from "./customization/lib";
import { StoreCategory } from "./customization/category";

export default class extends Controller {
  static targets = ["button", "input"];
  static outlets = ["site-builder--color-palette"];

  static values = {
    theme: {
      type: String,
      default: "classic",
    },
  };

  initialize() {
    this.onChange = this.onChange.bind(this);
  }

  connect() {
    this.picker = Pickr.create({
      el: this.buttonTarget,
      theme: this.themeValue,
      swatches: this.swatches,
      components: this.componentOptions,
      position: this.position,
      comparison: false,
    });

    onCustomizationRendered(({ updates }) => {
      /*
          The iframe is not loaded yet to get the default colors to
          populate the color pickers.

          If color customization is already selected, skip adding defaults
       */
      if (updates?.[this.inputTarget.dataset.colorId]) return;

      this.setDefault();
    });

    this.picker.on("change", this.onChange);
  }

  setDefault() {
    const value = CustomizationRequest.getCssVariable(
      this.inputTarget.dataset.colorId
    );

    /*
        Don't want to trigger onchange event when setting defaults.
        .setColor raises onChange event
     */

    if (value) {
      const { values } = this.picker._parseLocalColor(value);
      this.picker.setHSVA(...values, true);
    }
  }

  disconnect() {
    this.picker.destroy();
  }

  onChange(color) {
    const value = color ? color.toHEXA().toString() : null;
    this.inputTarget.value = value;
    const id = this.inputTarget.dataset.colorId;

    Customization.localUpdate({ [id]: value }, StoreCategory.CSS);
    this.siteBuilderColorPaletteOutlet.showReset();
  }

  get position() {
    return "top-middle";
  }

  get componentOptions() {
    return {
      preview: true,
      hue: true,
      palette: true,

      interaction: {
        input: true,
      },
    };
  }

  get swatches() {
    return swatches;
  }
}
